import { BrandSectionAssetItemController } from './brand-section-asset-item.controller'

function brandSectionAssetItem () {
  return {
    restrict: 'E',
    scope: {
      asset: '=',
      section: '=',
      data: '=',
      viewMode: '=',
      disableControls: '<',
      openPreview: '&'
    },
    templateUrl: '/brand/directives/brand-section-asset-item/brand-section-asset-item-directive.html?$$REVISION$$',
    controller: BrandSectionAssetItemController
  }
}

export { brandSectionAssetItem }
